import React, { useState, useEffect } from 'react';
import { Card, Typography, Button } from '@mui/material';
import axios from 'axios';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

// Import help icon
import HelpIcon from '@mui/icons-material/Help';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import MouseIcon from '@mui/icons-material/Mouse';
import BrushIcon from '@mui/icons-material/Brush';
import MovingIcon from '@mui/icons-material/Moving';

export default function InfoDialog(props) {
    const [open, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }

    const shortCuts = [
        {
            name: "General",
            icon: <MouseIcon color="primary" />,
            items: [
                {
                    name: "Zoom In/Out",
                    value: "Mouse Wheel"
                },
                {
                    name: "Pan",
                    value: "Right Mouse button + Drag"
                },
                {
                    name: "Draw Point",
                    value: "Click on Image"
                },
                {
                    name: "Move Point",
                    value: "Click + Mouse Drag"
                }
            ]
        },
        
    ]

    return (
        <>
                <Button
                    size='small'
                    style={{ paddingLeft: 1, paddingRight: 1, width: 30 }}
                    variant='contained'
                    onClick={() => setOpen(true)}>
                    <HelpIcon size={2} />
                </Button>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Keyboard and Mouse</DialogTitle>
                <DialogContent style={{ width: 500 }}>
                    <MenuList>
                        {shortCuts.map((shortCutType, index) => {

                            return (
                                <span key={`st-${index}`}>
                                    <MenuItem style={{ backgroundColor: "#eee" }}>
                                        <ListItemIcon>
                                            {shortCutType.icon}
                                        </ListItemIcon>
                                        <ListItemText style={{ fontWeight: "bold", color: "#06f" }}>{shortCutType.name}</ListItemText>
                                    </MenuItem>

                                    {shortCutType.items.map((shortCut, indexq) => {
                                        return (
                                            <MenuItem key={`sc-${index}-${indexq}`} style={{ paddingLeft: 40 }}>
                                                <ListItemText>{shortCut.name}
                                                </ListItemText>
                                                <Typography variant="body2" color="text.secondary">
                                                    {shortCut.value}
                                                </Typography>
                                            </MenuItem>
                                        )
                                    })}

</span>
                            )
                        })}
                    </MenuList>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}

